export default function About() {
  return (
    <section
      className="min-h-screen px-6 py-20 bg-white dark:bg-gray-900 text-gray-800 dark:text-white flex items-center"
      id="about"
    >
      <div className="max-w-4xl ml-8 md:ml-16">
        <h1 className="text-5xl font-black font-sans mb-4">
          <span className="text-gray-900 dark:text-white">STIVENS</span>{" "}
          <span className="text-blue-600 dark:text-blue-400">MEJIA-CORNELIO</span>
        </h1>

        <p className="text-lg leading-relaxed mt-6">
          I’m a Systems Engineer with a passion for building reliable, secure, and
          scalable IT infrastructure. With 7+ years of hands-on experience across
          enterprise healthcare and corporate environments, I specialize in Linux
          systems administration, virtualization (VMware/Proxmox), Active Directory,
          and automating infrastructure across AWS and Azure.
        </p>
        <p className="text-lg leading-relaxed mt-4">
          My current focus is on cloud-native technologies like Kubernetes,
          infrastructure as code with Terraform and Ansible, and CI/CD pipelines. I
          enjoy solving real-world problems by blending on-prem systems with cloud
          platforms to deliver performant, secure, and maintainable solutions.
        </p>
        <p className="text-lg leading-relaxed mt-4">
          Outside of work, I’m constantly learning and refining my skills through
          homelab projects and certification goals. I’m driven by a deep curiosity and
          a love for clean, efficient systems.
        </p>
      </div>
    </section>
  );
}
